import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { HttpService } from 'src/app/services/http.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { APINoDataResponse, ContactFormData } from 'src/app/interfaces';
import { ContactModalComponent } from 'src/app/private/pages/faq/contact-modal/contact-modal.component';

@Component({
  selector: 'app-error-dialog',
  templateUrl: './error-dialog.component.html',
})
export class ErrorDialogComponent {
  @Input() titleKey!: string;
  @Input() messageKey?: string;
  @Input() reasons?: string[];
  @Input() instructionKey?: string;
  @Input() primaryActionLabelKey?: string;
  @Input() secondaryActionLabelKey?: string;
  @Input() showSupportAction: boolean = false;

  @Output() primaryAction = new EventEmitter<void>();
  @Output() secondaryAction = new EventEmitter<void>();
  @Output() dismissed = new EventEmitter<void>();

  constructor(
    private dialog: MatDialog,
    private http: HttpService,
    private spinner: NgxSpinnerService,
    private snackBar: MatSnackBar,
    private analytics: AnalyticsService,
  ) {}

  onSupportClick(): void {
    if (environment.faq.contactInApp) {
      this.analytics.logEvent('open_contact_modal');
      const dialogRef = this.dialog.open(ContactModalComponent, {
        width: '100%',
        height: '100%',
        maxWidth: '100%',
        maxHeight: '100%',
        data: { isLogged: true }
      });
      dialogRef.afterClosed().subscribe((formData: ContactFormData) => {
        if (!formData) return;
        this.submitHelp(formData);
      });
    } else {
      environment.faq.goToContact();
    }
  }

  private submitHelp(contactFormData: ContactFormData): void {
    this.analytics.logEvent('submit_sent', { origin: 'error_dialog' });
    this.spinner.show();

    const helpPromise: Promise<APINoDataResponse> = contactFormData.transactionId
      ? this.http.transactionsHelp(contactFormData.transactionId, contactFormData)
      : this.http.usersHelp(contactFormData);

    helpPromise
      .then((response: APINoDataResponse) => {
        if (response.successful) {
          this.snackBar.open('Tu mensaje fue enviado correctamente.', 'Cerrar', { duration: 10000 });
        } else {
          this.analytics.logEvent('submit_sent_error', { origin: 'error_dialog' });
        }
      })
      .catch(() => {
        this.analytics.logEvent('submit_sent_error', { origin: 'error_dialog' });
      })
      .finally(() => {
        this.spinner.hide();
      });
  }
}
